export const DORMITORY = '/dormitory'
export const ACCOMMODATION_REQUESTS = '/accommodation-requests'
